import React from 'react';

const CHOICES = [
  "not satisfied",
  "slightly satisfied",
  "neutral",
  "satisfied",
  "very satisfied"
];

export default class SatisfactionSelector extends React.Component {
  constructor(props) {
    super();
    this.choices = props.choices || CHOICES;
    this.state = { choice: null };
    this.state.message = props.message || "Please make your choice...";
  }

  handleChange(choice) {
    this.setState({ choice, message: this.choices[choice] });
    if (this.props.onChange) {
      this.props.onChange(choice);
    }
  }

  getStyle(choice) {
    const style = {
      fontSize: "2.50rem",
      textAlign: "center",
      borderRadius: "5px",
      cursor: "pointer"
    };
    if (choice === this.state.choice) {
      style.color = "#fff";
      style.backgroundColor = "#888"
      return style;
    } else {
      style.color = "#000";
      style.backgroundColor = "transparent"
      return style;
      }
  }

  render() {
    const props = this.props;
    const id = props.id || 'input-' + props.name;
    const label = props.label === null ? null :
    (<label htmlFor={id} className="col-xs-12">
      {props.label || props.name}
    </label>);
    let message = this.state.message;
    return (
      <div className="form-group SatisfactionSelector">
        {label}
        <div>
          <div
            className="col-xs-1 SatisfactionSelector-choice"
            style={this.getStyle(0)}
            onClick={() => this.handleChange(0)}
            >🙁</div>
          <div
            className="col-xs-1 SatisfactionSelector-choice"
            style={this.getStyle(1)}
            onClick={() => this.handleChange(1)}
            >😕</div>
          <div
            className="col-xs-1 SatisfactionSelector-choice"
            style={this.getStyle(2)}
            onClick={() => this.handleChange(2)}
            >😐</div>
          <div
            className="col-xs-1 SatisfactionSelector-choice"
            style={this.getStyle(3)}
            onClick={() => this.handleChange(3)}
            >🙂</div>
          <div
            className="col-xs-1 SatisfactionSelector-choice"
            style={this.getStyle(4)}
            onClick={() => this.handleChange(4)}
            >😃</div>
        </div>
        <span className="col-xs-12 help-block">{message}</span>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/SatisfactionSelector.jsx